<template>
    <base-error>
        <template #image>
            <img class="width-px-99 d-block m-auto" src="@assets/images/ss-logo-white-bg.png" alt="Sellers Shield"
                 title="Sellers Shield">
        </template>
        <template #title>
            404
        </template>
        <template #description>
            <h2 class="text-center">The page you seek doesn't exist.</h2>
            <p class="text-center">Think you're seeing this message in error?<br><span
                class="mobile-spacer">&nbsp;</span>Please
                <a :href="contactUrl">let us know.</a></p>
        </template>
    </base-error>
</template>

<script>
import BaseError from "@components/errors/BaseError";

export default {
    name: "NotFound",
    components: {BaseError},
    computed: {
        contactUrl() {
            return window.env.SS_BASE_URL + '/contact';
        }
    }
}
</script>